import { Keys, Scene } from "excalibur";
import { OpenHive } from "../../actors/openHive";
import { Player } from "../../player";
import { sendAlert, splitHive, startStingTimer } from "../../utils";
import { goToScene } from "../../main";
import { Resources } from "../../Resources";
import { playerState } from "../../state/stateManager";
export default class SplitMenu extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;

    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 2;
    this.playerAnim = false;
    this.donationFrameCount = 1;
    this.foodFrameCount = 0;
    this.stage = 0;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.includeQueenCells = false;
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);
    this.maxBroodFrames = this.hiveStats.broodFrames.count - 1;
    Resources.BeeSounds.play();
    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.splitMenu = document.getElementById("split-menu");
    console.log("splitMenu: ", this.splitMenu);
    this.splitMenu.style.display = "block";
    this.splitMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showSplitMenu(0, this.hiveStats, this.donationFrameCount)}
        `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "inspect",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onDeactivate() {
    this.stingTimer && this.stingTimer.stop();
    this.selected = null;
    this.activeItem = 0;
    this.hive.kill();
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      Resources.Click.play();
      switch (this.stage) {
        case 0:
          if (this.donationFrameCount < this.maxBroodFrames) {
            this.donationFrameCount++;
          }
          break;
        case 1:
          if (this.foodFrameCount + 1 < this.hiveStats.foodFrames.count) {
            this.foodFrameCount++;
          }
          break;
        case 2:
          if (this.hiveStats.queenCells.count == 0) {
            this.includeQueenCells = false;
          } else {
            this.includeQueenCells = !this.includeQueenCells;
          }

          break;
        default:
          break;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      switch (this.stage) {
        case 0:
          if (this.donationFrameCount !== 1) {
            this.donationFrameCount = this.donationFrameCount - 1;
          }
          break;
        case 1:
          if (this.foodFrameCount !== 0) {
            this.foodFrameCount = this.foodFrameCount - 1;
          }
          break;
        case 2:
          if (this.hiveStats.queenCells.count == 0) {
            this.includeQueenCells = false;
          } else {
            this.includeQueenCells = !this.includeQueenCells;
          }
          break;
        default:
          break;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.stage == 2) {
        //split hive
        if (this.donationFrameCount > 0) {
          Resources.WoodSound.play();
          let splitRes = splitHive(this.hiveStats, {
            broodFrames: this.donationFrameCount,
            foodFrames: this.foodFrameCount,
            queenCells: {
              include: this.includeQueenCells,
              cells: this.hiveStats.queenCells,
            },
          });
          if (splitRes) {
            this.menuContainer.style.display = "none";
            this.splitMenu.style.display = "none";
            this.donationFrameCount = 0;
            this.foodFrameCount = 0;
            this.stage = 0;
            goToScene("hiveMenu", this.hiveStats);
          }
        }
      } else {
        this.stage++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      this.menuContainer.style.display = "none";
      this.splitMenu.style.display = "none";
      this.stage = 0;
      this.donationFrameCount = 1;
      this.foodFrameCount = 0;
      this.includeQueenCells = false;
      goToScene("hiveMenu", this.hiveStats);
    }
    switch (this.stage) {
      case 0:
        this.splitMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showSplitMenu(0, this.hiveStats, this.donationFrameCount)}
        `;
        break;
      case 1:
        this.splitMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showFoodMenu(0, this.hiveStats, this.foodFrameCount)}
        `;
        break;
      case 2:
        this.splitMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showQueenCellMenu(
          0,
          this.hiveStats,
          this.donationFrameCount,
          this.includeQueenCells
        )}
        `;
        break;
      case 3:
        break;
      default:
        break;
    }
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    } else {
      this.player.doAnim("addBox");
    }
  }
}
function showSplitMenu(active, hiveStats, donationFrameCount) {
  if (active === 0) {
    return `<h3>Split Hive</h3><br/>
    <h3>Move Brood Frame(s) For Split</h3><hr/>
        <p>Hive Has ${hiveStats.broodFrames.frames.length} Brood Frames</p>
        <p>How Many Brood Frames?</p>
        <h3>${donationFrameCount}</h3>
        <p>Use Arrow Keys To Iterate <br/> Enter To Continue</p>
        `;
  }
}

function showFoodMenu(active, hiveStats, foodFrameCount) {
  if (active === 0) {
    return `<h3>Split Hive</h3><br/>
      <h3>Move Food Frame(s) For Split</h3><hr/>
          <p>Hive Has ${parseInt(hiveStats.foodFrames.count)} Food Frames</p>
          <p>How Many Food Frames?</p>
          <h3>${foodFrameCount}</h3>
          <p>Use Arrow Keys To Iterate <br/> Enter To Continue</p>
          `;
  }
}

function showQueenCellMenu(
  active,
  hiveStats,
  donationFrameCount,
  includeQueenCells
) {
  if (active === 0) {
    return `<h3>Split Hive</h3><br/>
      <h3>Include Queen Cells?</h3><hr/>
        <p>Hive Has ${hiveStats.queenCells.count} Queen Cells</p>
          <h3>${includeQueenCells ? "YES" : "NO"}</h3>
          <p>Use Arrow Keys To Iterate <br/> Enter To Continue</p>
          `;
  }
}
